import { useEffect, useRef, useState } from 'react';

const stats = [
  { value: 1000, suffix: '+', label: 'Аптек по всей России', icon: 'ri-store-2-line', color: '#ff2d78' },
  { value: 15, suffix: '', label: 'Лет на рынке', icon: 'ri-calendar-line', color: '#00f5ff' },
  { value: 50000, suffix: '+', label: 'Наименований товаров', icon: 'ri-capsule-line', color: '#39ff14' },
  { value: 2, suffix: 'млн+', label: 'Клиентов ежемесячно', icon: 'ri-group-line', color: '#f0ff00' },
  { value: 24, suffix: '/7', label: 'Работаем без выходных', icon: 'ri-time-line', color: '#ff6b00' },
  { value: 99, suffix: '%', label: 'Довольных покупателей', icon: 'ri-star-line', color: '#ff2d78' },
];

const useCountUp = (target: number, duration = 1800, active: boolean) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!active) return;
    let start = 0;
    const step = target / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= target) { setCount(target); clearInterval(timer); }
      else setCount(Math.floor(start));
    }, 16);
    return () => clearInterval(timer);
  }, [target, duration, active]);
  return count;
};

const StatCard = ({ stat, active }: { stat: typeof stats[0]; active: boolean }) => {
  const count = useCountUp(stat.value, 1600, active);
  return (
    <div
      className="card-cyber rounded-2xl p-6 flex flex-col items-center text-center group transition-all duration-300"
      style={{ borderColor: `${stat.color}20` }}
    >
      <div
        className="w-12 h-12 flex items-center justify-center rounded-xl mb-4"
        style={{ background: `${stat.color}15`, border: `1px solid ${stat.color}40` }}
      >
        <i className={`${stat.icon} text-xl`} style={{ color: stat.color }} />
      </div>
      <div
        className="font-orbitron font-black text-3xl md:text-4xl mb-1"
        style={{ color: stat.color, textShadow: `0 0 15px ${stat.color}60` }}
      >
        {count.toLocaleString()}{stat.suffix}
      </div>
      <p className="font-mono text-xs text-white/40 leading-relaxed">{stat.label}</p>
      <div
        className="absolute bottom-0 left-0 right-0 h-0.5 rounded-b-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        style={{ background: `linear-gradient(90deg, transparent, ${stat.color}, transparent)` }}
      />
    </div>
  );
};

const AboutStats = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setActive(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="px-6 lg:px-12 pb-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {stats.map((s) => (
            <StatCard key={s.label} stat={s} active={active} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutStats;
